import styled from "styled-components";

export const GamePlayPcHeaderBarFreePlayLabelDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 350px;
    height: 100%;
    background-color: ${props => props.theme.colors.brandSecondary};
    color: ${props => props.theme.colors.background};
    ${({theme}) => theme.font.presets.bold};
    font-size: 2rem;
    text-align: center;
`

